import {ReactComponent} from '../app'
import {Button, Card, Col, Row, Spin} from 'antd'
import pizzaImage from '../gfx/images/pizza.jpg'
import food02Image from '../gfx/images/food02.jpg'
import CardImageBackground from '../components/cards/CardImageBackground'
import BottomSheetCard from '../components/cards/BottomSheetCard'
import OverlayContent from '../components/layout/OverlayContent'
import App from '../app/App'

export default class FoodMenuPage extends ReactComponent {
  state = {
    loading: true,
    lobsterFamilyMenu: "",
    lobsterFamilyMenuLoading: false,
    lobsterFamilyMenuActive: false,
    lobsterBistroMenu: "",
    lobsterBistroMenuLoading: false,
    lobsterBistroMenuActive: false,
  }

  async componentDidMount() {
    void this.updateState({loading: true})

    /* TODO: CHANGE PATH */
    fetch(App.API_URL + '/lobster-menu.php').then(res => res).then(async (res) => {
      const content = await res.text()

      void this.updateState({
        lobsterFamilyMenu: content,
        lobsterFamilyMenuLoading: false,
      })

    })

    fetch(App.API_URL + '/lobster-bistro-menu.php').then(res => res).then(async (res) => {
      const content = await res.text()

      void this.updateState({
        lobsterBistroMenu: content,
        lobsterBistroMenuLoading: false,
      })

    })

  }

  openLobsterMenu = () => {
    void this.updateState({lobsterFamilyMenuActive: true})
  }
  openBistroMenu = () => {
    void this.updateState({lobsterBistroMenuActive: true})
  }

  closeLobsterMenu = () => {
    void this.updateState({lobsterFamilyMenuActive: false})
  }
  closeLobsterBistroMenu = () => {
    void this.updateState({lobsterBistroMenuActive: false})
  }

  render() {
    return (
      <>
        <section className="container full-height centered mb-3">

          <h1 className="main-title">Naše menu</h1>

          <Row gutter={[24, 32]}>
            <Col sm={24} xs={24}>
              <CardImageBackground image={pizzaImage}>
                <Button type="default" block onClick={this.openLobsterMenu}>LOBSTER Family restaurant</Button>
              </CardImageBackground>
            </Col>
            <Col sm={24} xs={24}>
              <CardImageBackground image={food02Image}>
                <Button type="default" block onClick={this.openBistroMenu}>LOBSTER Bistro</Button>
              </CardImageBackground>
            </Col>
          </Row>
        </section>

        <OverlayContent
          classes="food-menu"
          loading={this.state.lobsterFamilyMenuLoading}
          active={this.state.lobsterFamilyMenuActive}
          onClose={() => {
            void this.updateState({lobsterFamilyMenuActive: false})
          }}
        >
          <div dangerouslySetInnerHTML={{__html: this.state.lobsterFamilyMenu}}></div>
          <div className="menu-spacer"></div>
        </OverlayContent>

        <OverlayContent
          classes="food-menu"
          loading={this.state.lobsterBistroMenuLoading}
          active={this.state.lobsterBistroMenuActive}
          onClose={() => {
            void this.updateState({lobsterBistroMenuActive: false})
          }}
        >
          <h1 className="page-title">Týdení menu</h1>
          <div dangerouslySetInnerHTML={{__html: this.state.lobsterBistroMenu}}></div>
          <div className="menu-spacer"></div>
        </OverlayContent>

      </>
    )
  }
}